<template>
  <ListItem
    component="button"
    type="button"
    @click="$emit('click', 'contact-details')"
  >
    <ListItemAction>
      <CardAccountDetailsOutlineIcon size="1.5rem" />
    </ListItemAction>
    <ListItemContent>
      <ListItemTitle>Contact details</ListItemTitle>
      <ListItemSubtitle wrap
        >Display your contact details for visitors.
      </ListItemSubtitle>
    </ListItemContent>
  </ListItem>
</template>

<script>
import {
  ListItem,
  ListItemAction,
  ListItemContent,
  ListItemSubtitle,
  ListItemTitle,
  CardAccountDetailsOutlineIcon,
} from '@campsite-bio/component-lib';

export default {
  components: {
    ListItem,
    ListItemAction,
    ListItemContent,
    ListItemSubtitle,
    ListItemTitle,
    CardAccountDetailsOutlineIcon,
  },
};
</script>

<style lang="scss" scoped></style>
